<template>
  <v-menu
    rounded="md"
    offset-y
    class="chat-message-menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="chat-message-menu__button"
        v-bind="attrs"
        v-on="on"
        icon
        small
      >
        <v-icon color="bhGray--2" size="16">bhi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list class="py-1">
      <v-list-item
        class="chat-message-menu__list-item px-3"
        v-if="isMessageOwner"
        @click="$emit('editMessage')"
      >
        <v-list-item-icon class="mr-1 my-2">
          <v-icon color="accent">bhi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-2">
          <v-list-item-title class="font-weight-bold accent--text">Edit</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        class="chat-message-menu__list-item px-3"
        v-if="isMessageOwner"
        @click="$emit('removeMessage')"
      >
        <v-list-item-icon class="mr-1 my-2">
          <v-icon color="accent">bhi-trash</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-2">
          <v-list-item-title class="font-weight-bold accent--text">Remove</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        class="chat-message-menu__list-item px-3"
        @click="$emit('copyMessage')"
      >
        <v-list-item-icon class="mr-1 my-2">
          <v-icon color="accent">bhi-copy-file</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-2">
          <v-list-item-title class="font-weight-bold accent--text">Copy</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        class="chat-message-menu__list-item px-3"
        v-if="!isMessageOwner && isRoleAllowed && directChat"
        @click="$emit('askAi')"
      >
        <v-list-item-icon class="mr-1 my-2">
          <v-icon color="accent">bhi-ask-hs</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-2">
          <v-list-item-title class="font-weight-bold accent--text">Hey Sammi</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'ChatMessageMenu',
  props: {
    isMessageOwner: {
      type: Boolean,
      default: false
    },
    isRoleAllowed: {
      type: Boolean,
      default: false
    },
    directChat: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .chat-message-menu {
    &__button {
      z-index: 2;
    }

    &__list-item {
      min-height: 32px;
    }
  }
</style>